import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';

import { CenteredLoader } from '@playbookux/playbook-web-core';
import { GET_TESTERS_BY_PROJECT_ID } from '../graphql';

import Card from '../card';
import SessionsTable from './sessions-table';
import {
  Container,
  Link,
  Text,
} from '../styles';
import { registerFunctions } from '../../../../../core/hooks/use-function-handler';

// eslint-disable-next-line max-len
const TEXT = 'When a participant schedules a session, their information and a Zoom link will appear here. You will also receive a calendar invite. No one has booked time yet';

const ConfirmedSessions = (props) => {
  const {
    project,
    handleModalOpen,
    timeZone,
    scope,
  } = props;

  const {
    id: projectId,
    company,
    participantsSource,
    surveys,
    segments,
  } = project;

  const {
    callLink,
  } = company;

  const {
    data = {},
    loading,
    refetch,
  } = useQuery(GET_TESTERS_BY_PROJECT_ID, {
    variables: {
      projectId,
      limit: 100,
      offset: 0,
      hideNoScheduled: true,
    },
  });

  const { segmentsCount = 0 } = data || {};
  let { testers = [] } = data || {};
  testers = testers.filter((t) => {
    const sessions = t.testSessions.filter((session) => !session.removed);
    return t.testSessions && sessions.length;
  });

  const refetchData = () => {
    refetch();
  };

  if (loading) {
    return <CenteredLoader />;
  }

  registerFunctions('confirmed_sessions', {
    func1: refetchData,
  });

  return (
    <Card
      title="Confirmed sessions"
      subtitle={(
        <Link
          href="http://help.playbookux.com/en/articles/4430929-moderated-interview-faqs"
          target="_blank"
        >
          Reschedule & cancellation policies
        </Link>
      )}
    >
      {
        !(testers && testers.length)
          ? <Text>{TEXT}</Text>
          : (
            <Container>
              <SessionsTable
                testers={testers}
                timeZone={timeZone}
                callLink={callLink}
                participantsSource={participantsSource}
                surveys={surveys}
                handleModalOpen={handleModalOpen}
                segmentsCount={segmentsCount}
                segments={segments}
                company={company}
                scope={scope}
              />
            </Container>
          )
      }
    </Card>
  );
};

ConfirmedSessions.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.string.isRequired,
    participantsSource: PropTypes.string,
    surveys: PropTypes.oneOfType([PropTypes.array]),
    segments: PropTypes.oneOfType([PropTypes.array]),
    company: PropTypes.shape({
      callLink: PropTypes.string,
    }).isRequired,
  }).isRequired,
  handleModalOpen: PropTypes.func.isRequired,
  timeZone: PropTypes.string.isRequired,
  scope: PropTypes.string.isRequired,
};

export default ConfirmedSessions;
